// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__83-kv","title":"Info_title__17Ob7","links":"Info_links__2xhMv","link":"Info_link__MWwV8","logo":"Info_logo__2FYOe"};